import ProjectListPageReducer from './ProjectListPageReducer';

export default from './ProjectListPageContainer';

export const ProjectListPageReducers = {
  ProjectListPageReducer,
};
